import { string } from 'prop-types'
import { Container } from '@mch-group/uikit-components'
import { connect } from 'react-redux'

import Text from './Text'
import cssClasses from '../constants/cssClasses'

const ApiResponseError = props => (
  <section className={`${props.className} ${cssClasses.CMS_MODULE}`}>
    <Container className={`${props.mID} px-5 px-lg-8 px-md-7`}>
      <Text isHtml forwardedAs='p'>
        {props.errorLabel
          ? props.errorLabel
          : 'This functionality is not available right now. Please try again later.'}
      </Text>
    </Container>
  </section>
)

ApiResponseError.propTypes = {
  className: string,
  mID: string,
  errorLabel: string
}

export default connect(
  //@ts-ignore
  ({ shared: { globalModules: { generalNotificationModule: { labels } } } }) => ({
    errorLabel: (labels || {}).gnm_grp1_crm_login_500
  }),
  null
)(ApiResponseError)
